import { useEffect } from "react";

const SITE = "Jessica Dannielle Johnson";
const OG_IMAGE = "https://jessicadannielle.com/assets/og-share.jpg";

const upsert = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : SITE;
    document.title = fullTitle;
    if (description) upsert("name", "description", description);
    upsert("property", "og:title", fullTitle);
    if (description) upsert("property", "og:description", description);
    upsert("property", "og:image", OG_IMAGE);
    upsert("property", "og:type", "website");
    upsert("name", "twitter:card", "summary_large_image");
    upsert("name", "twitter:title", fullTitle);
    if (description) upsert("name", "twitter:description", description);
    upsert("name", "twitter:image", OG_IMAGE);
  }, [title, description]);
  return null;
};
